export default "__VITE_ASSET__CqUCOekq__"